import * as React from 'react';

export interface IMenuListProps {
	isHidden?: boolean;
}

export default class MenuList extends React.Component<IMenuListProps, {}> {
	public render() {
		if (this.props.isHidden) {
			return null;
		}

		return <ul className="menu-list">{this.props.children}</ul>;
	}
}
